export enum WatchDogStatus {
    FAILING = "failing",
    OK = "ok"
}
